import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Header from './Header';
import Sidebar from './Sidebar';
import MobileMenu from './MobileMenu';
import Breadcrumb from './Breadcrumb';

const NavigationLayout = ({
  children,
  showBreadcrumb = true,
  breadcrumbItems,
  className = '',
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const handleMenuClick = () => {
    // On mobile, show mobile menu; on desktop, toggle sidebar
    if (window.innerWidth < 1024) {
      setIsMobileMenuOpen(true);
    } else {
      setIsSidebarOpen(!isSidebarOpen);
    }
  };

  const handleSidebarToggle = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div className={`min-h-screen bg-gray-50 ${className}`}>
      {/* Mobile Menu */}
      <MobileMenu isOpen={isMobileMenuOpen} onClose={closeMobileMenu} />

      {/* Desktop Layout */}
      <div className="flex h-screen">
        {/* Desktop Sidebar */}
        <div className={`hidden lg:flex lg:flex-shrink-0 transition-all duration-300 ${isSidebarCollapsed ? 'lg:w-16' : 'lg:w-64'}`}>
          <Sidebar 
            isOpen={true} 
            onClose={closeSidebar} 
            isCollapsed={isSidebarCollapsed}
            onToggle={handleSidebarToggle}
            className="relative" 
          />
        </div>

        {/* Main Content Area */}
        <div className="flex flex-col flex-1 min-w-0">
          {/* Header */}
          <Header onMenuClick={handleMenuClick} />

          {/* Breadcrumb */}
          {showBreadcrumb && (
            <div className="bg-white border-b border-gray-200 px-4 sm:px-6 lg:px-8 py-3">
              <Breadcrumb items={breadcrumbItems} />
            </div>
          )}

          {/* Main Content */}
          <main className="flex-1 overflow-y-auto">
            <div className="px-4 sm:px-6 lg:px-8 py-6">{children}</div>
          </main>
        </div>
      </div>
    </div>
  );
};

NavigationLayout.propTypes = {
  children: PropTypes.node.isRequired,
  showBreadcrumb: PropTypes.bool,
  breadcrumbItems: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      href: PropTypes.string,
      current: PropTypes.bool,
    })
  ),
  className: PropTypes.string,
};

export default NavigationLayout;
